import React from 'react';
import { Box } from '@mui/material';
import { StyledButton } from '../../styles/StyledButtons';

interface DangerZoneProps {
  onDeleteClick: () => void;
}

const DangerZone: React.FC<DangerZoneProps> = ({ onDeleteClick }) => (
  <Box sx={{ display: 'flex', justifyContent: 'flex-start' }}>
    <StyledButton noTopSpacing buttonVariant="warning" onClick={onDeleteClick}>
      Delete Fund
    </StyledButton>
  </Box>
);

export default DangerZone;
